define([], function(){
    var helpDictionary = null;
    function help(response) {
        if(helpDictionary == null){
            var path = __webpack_public_path__ + "\\uResponses.json";
            var request = new XMLHttpRequest();
            request.open('GET', path, false);  
            request.send(null);
            if (request.status === 200) {
                helpDictionary = {}
                var data = JSON.parse(request.responseText);
                data.responses.forEach(function (response) {
                    helpDictionary[response.name] = response;
                });
            }
        }
        return helpDictionary?helpDictionary[response]:null;
    }
    return help;
});


//////////////////
// WEBPACK FOOTER
// ./help.js
// module id = 1
// module chunks = 0